import { render, staticRenderFns } from "./MessageCard.vue?vue&type=template&id=a578be56&"
import script from "./MessageCard.vue?vue&type=script&setup=true&lang=ts&"
export * from "./MessageCard.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports